import { ENV, TFI } from "../../client-config";

const requireImage = (image) => image.default || image;

const dev = {
  adminIconColored: requireImage(require("./dev/admin_icon_green.svg")),
  alertsIconColored: requireImage(require("./dev/alerts_icon_green.svg")),
  backArrowColored: requireImage(require("./dev/back_arrow_green.svg")),
  barcodeIconColored: requireImage(require("./dev/barcode_icon_green.svg")),
  bottomArrowColored: requireImage(require("./dev/bottom_arrow_green.svg")),
  cameraIconColored: requireImage(require("./dev/camera_icon_green.svg")),
  checkCircleColored: requireImage(require("./dev/check_circle_green.svg")),
  checkmarkColored: requireImage(require("./dev/checkmark.svg")),
  commentsIconColored: requireImage(require("./dev/comments_icon_green.svg")),
  dashboardIconColored: requireImage(require("./dev/dashboard_icon_green.svg")),
  downloadIconColored: requireImage(require("./dev/download_icon_green.svg")),
  driveInOutColored: requireImage(require("./dev/drive_in_out_green.svg")),
  editIconColored: requireImage(require("./dev/edit_icon.svg")),
  eventsIconColored: requireImage(require("./dev/events_icon_green.svg")),
  expandMenuColored: requireImage(require("./dev/expand_menu_icon.svg")),
  faceIdIconColored: requireImage(require("./dev/faceid_icon_green.svg")),
  hspIconColored: requireImage(require("./dev/hsp_icon_green.svg")),
  logoutIconColored: requireImage(require("./dev/logout_icon_green.svg")),
  mdcIconColored: requireImage(require("./dev/mdc_icon_green.svg")),
  meColored: requireImage(require("./dev/me_green.svg")),
  menuArrowColored: requireImage(require("./dev/menu_arrow_green.svg")),
  menuMobileColored: requireImage(require("./dev/menu_mobile_green.svg")),
  myAccountIconColored: requireImage(require("./dev/my_account_icon_green.svg")),
  plusIconColored: requireImage(require("./dev/plus_icon_green.svg")),
  printIconColored: requireImage(require("./dev/print_icon_green.svg")),
  profilesIconColored: requireImage(require("./dev/profiles_icon_green.svg")),
  rightArrowColored: requireImage(require("./dev/right_arrow_green.svg")),
  schedulerIconArrowColored: requireImage(require("./dev/scheduler_icon_arrow_green.svg")),
  schedulerIconColored: requireImage(require("./dev/scheduler_icon_green.svg")),
  siteEntranceIconColored: requireImage(require("./dev/site_entrance_icon_green.svg")),
  siteViewIconColored: requireImage(require("./dev/site_view_icon_green.svg")),
  tabHistoryColored: requireImage(require("./dev/tab_history_green.svg")),
  walkInColored: requireImage(require("./dev/walk_in_green.svg")),
  walkInOutColored: requireImage(require("./dev/walk_in_out_green.svg")),
  walkOutColored: requireImage(require("./dev/walk_out_green.svg")),
};

const tfi = {
  adminIconColored: requireImage(require("./tfi/admin_icon_tfi.svg")),
  backArrowColored: requireImage(require("./tfi/back_arrow_tfi.svg")),
  checkCircleColored: requireImage(require("./tfi/check_circle_tfi.svg")),
  checkmarkColored: requireImage(require("./tfi/checkmark_tfi.svg")),
  dashboardIconColored: requireImage(require("./tfi/dashboard_icon_tfi.svg")),
  driveInOutColored: requireImage(require("./tfi/drive_in_out_tfi.svg")),
  editIconColored: requireImage(require("./tfi/edit_icon_tfi.svg")),
  eventsIconColored: requireImage(require("./tfi/events_icon_tfi.svg")),
  expandMenuColored: requireImage(require("./tfi/expand_menu_icon_tfi.svg")),
  logoutIconColored: requireImage(require("./tfi/logout_icon_tfi.svg")),
  meColored: requireImage(require("./tfi/me_tfi.svg")),
  myAccountIconColored: requireImage(require("./tfi/my_account_icon_tfi.svg")),
  plusIconColored: requireImage(require("./tfi/plus_icon_tfi.svg")),
  profilesIconColored: requireImage(require("./tfi/profiles_icon_tfi.svg")),
  siteEntranceIconColored: requireImage(require("./tfi/site_entrance_icon_tfi.svg")),
  tabHistoryColored: requireImage(require("./tfi/tab_history_tfi.svg")),
  tfiLogo: requireImage(require("./tfi/tfi.png")),
  tfiSign: requireImage(require("./tfi/tfi_sign.svg")),
  walkInOutColored: requireImage(require("./tfi/walk_in_out_tfi.svg")),
};

const common = {
  adminIconBlack: requireImage(require("./common/admin_icon_black.svg")),
  time: requireImage(require("./common/time.svg")),
  alertsIconBlack: requireImage(require("./common/alerts_icon_black.svg")),
  allowedGrey: requireImage(require("./common/allowed_grey.svg")),
  allowedWhite: requireImage(require("./common/allowed_white.svg")),
  arrowClosedBlack: requireImage(require("./common/arrow_open_black.svg")),
  scanner: requireImage(require("./common/mdi_barcode_scan.svg")),
  arrowOpenBlack: requireImage(require("./common/arrow_closed_black.svg")),
  averageTime: requireImage(require("./common/average_time_icon.svg")),
  averageTimeGateIcon: requireImage(require("./common/average_time_gate_icon.svg")),
  awsLogo: requireImage(require("./common/aws_logo.svg")),
  what: requireImage(require("./common/what.svg")),
  barcodeIconBlack: requireImage(require("./common/barcode_icon_black.svg")),
  meBlack: requireImage(require("./common/black.svg")),
  load: requireImage(require("./common/load.svg")),
  unload: requireImage(require("./common/unload.svg")),
  move: requireImage(require("./common/move.svg")),
  drop: requireImage(require("./common/drop.svg")),
  pickup: requireImage(require("./common/pickup.svg")),
  switch2: requireImage(require("./common/switch_2.svg")),
  liveload: requireImage(require("./common/live_load.svg")),
  liveunload: requireImage(require("./common/live_unload.svg")),
  barcodeIconGrey: requireImage(require("./common/barcode_icon_grey.svg")),
  barcodeMatched: requireImage(require("./common/barcode_matched.svg")),
  barcodeMatchedGreen: requireImage(require("./common/barcode_match_green.svg")),
  barcodeMatchedRed: requireImage(require("./common/barcode_match_red.svg")),
  barcodeMismatchIcon: requireImage(require("./common/barcode_mismatch_icon.svg")),
  barcodeUnmatched: requireImage(require("./common/barcode_unmatched.svg")),
  bottomArrow: requireImage(require("./common/bottom_arrow_icon.svg")),
  bottomArrowLight: requireImage(require("./common/bottom_arrow_light.svg")),
  bottomArrowWhite: requireImage(require("./common/bottom_arrow_white.svg")),
  breadcrumbIcon: requireImage(require("./common/breadcrumb_icon.svg")),
  breadcrumbIconBlack: requireImage(require("./common/breadcrumb_icon_black.svg")),
  calendarIcon: requireImage(require("./common/calendar_icon.svg")),
  cameraIcon: requireImage(require("./common/camera_icon.svg")),
  cameraPhotoIcon: requireImage(require("./common/camera_photo_icon.svg")),
  car: requireImage(require("./common/car_icon.svg")),
  carIconGrey: requireImage(require("./common/car_icon_grey.svg")),
  carrierIcon: requireImage(require("./common/carrier_icon.svg")),
  checklistButton: requireImage(require("./common/checklist_button.svg")),
  checklistIcon: requireImage(require("./common/checklist_icon.svg")),
  checklistIconBlack: requireImage(require("./common/checklist_icon_black.svg")),
  checklistIconWhite: requireImage(require("./common/checklist_icon_white.svg")),
  checkmarkGrey: requireImage(require("./common/checkmark_grey.svg")),
  checkmarkIcon: requireImage(require("./common/checkmark_black.svg")),
  checkmarkWhite: requireImage(require("./common/checkmark_white.svg")),
  chronoIconBlack: requireImage(require("./common/chrono_icon_black.svg")),
  clockArrowIcon: requireImage(require("./common/clock_arrow_icon.svg")),
  clockIcon: requireImage(require("./common/clock_icon.svg")),
  clockIconGrey: requireImage(require("./common/clock_icon_grey.svg")),
  closeIcon: requireImage(require("./common/close_icon.svg")),
  removeIcon: requireImage(require("./common/remove_icon.svg")),
  closeIconWhite: requireImage(require("./common/close_icon_white.svg")),
  commentIconBlack: requireImage(require("./common/comment_icon_black.svg")),
  companyIcon: requireImage(require("./common/company_icon.svg")),
  containerIconBlack: requireImage(require("./common/container_icon_black.svg")),
  containerIconGrey: requireImage(require("./common/container_icon_grey.svg")),
  containerLog: requireImage(require("./common/container_log.svg")),
  containerUnknown: requireImage(require("./common/container_Unknown.svg")),
  containerTrailerIcon: requireImage(require("./common/container_trailer_icon.svg")),
  containerUnknownLog: requireImage(require("./common/container_unknown_log.svg")),
  copyIconColored: requireImage(require("./common/copy_icon_green.svg")),
  dashboardIconGrey: requireImage(require("./common/dashboard_icon_grey.svg")),
  dataPrivacyIconBlack: requireImage(require("./common/data_privacy_icon_black.svg")),
  dataPrivacyIconGreen: requireImage(require("./common/data_privacy_icon_green.svg")),
  dataPrivacyIconOrange: requireImage(require("./common/data_privacy_icon_orange.svg")),
  dataPrivacyIconRed: requireImage(require("./common/data_privacy_icon_red.svg")),
  delete: requireImage(require("./common/delete.svg")),
  deleteIcon: requireImage(require("./common/delete_icon.svg")),
  deleteIconInactive: requireImage(require("./common/delete_icon_inactive.svg")),
  deletePhotoIcon: requireImage(require("./common/delete_photo_icon.svg")),
  delta: requireImage(require("./common/delta.svg")),
  iconPage: requireImage(require("./common/icon_paper.svg")),
  deniedGrey: requireImage(require("./common/denied_grey.svg")),
  deniedIcon: requireImage(require("./common/denied.svg")),
  deniedWhite: requireImage(require("./common/denied_white.svg")),
  driveInIcon: requireImage(require("./common/drive_in_icon.svg")),
  driveInOutGrey: requireImage(require("./common/drive_in_out_grey.svg")),
  driveOutIcon: requireImage(require("./common/drive_out_icon.svg")),
  driverAnim: requireImage(require("./animations/driver.gif")),
  driverIcon: requireImage(require("./common/driver_icon.svg")),
  driverIconBlack: requireImage(require("./common/driver_icon_black.svg")),
  greyCircle: requireImage(require("./common/grey_dot_20px_box.svg")),
  editIconDisabled: requireImage(require("./common/edit_icon_disabled.svg")),
  emailIcon: requireImage(require("./common/email_icon.svg")),
  errorIcon: requireImage(require("./common/error_icon.svg")),
  link: requireImage(require("./common/link.svg")),
  unlink: requireImage(require("./common/link_off.svg")),
  quantity_unit: requireImage(require("./common/ic_baseline_scale.svg")),
  eventsIconGrey: requireImage(require("./common/events_icon_grey.svg")),
  exitIcon: requireImage(require("./common/exit_icon.svg")),
  eyeBlack: requireImage(require("./common/eye_black.svg")),
  eyeIcon: requireImage(require("./common/eye_icon.png")),
  faceIdIconBlack: requireImage(require("./common/faceid_icon_black.svg")),
  faceMatched: requireImage(require("./common/face_matched.svg")),
  faceRecognized: requireImage(require("./common/face_recognized_icon.svg")),
  faceUnMatched: requireImage(require("./common/face_unmatched.svg")),
  frResult: requireImage(require("./common/fr_result.svg")),
  frResultGreen: requireImage(require("./common/fr_result_green.svg")),
  fuel0: requireImage(require("./common/fuel_0.png")),
  fuel1: requireImage(require("./common/fuel_1.png")),
  fuel12: requireImage(require("./common/fuel_12.png")),
  fuel14: requireImage(require("./common/fuel_14.png")),
  fuel34: requireImage(require("./common/fuel_34.png")),
  fuelIcon: requireImage(require("./common/fuel_icon.svg")),
  greenCheckmark: requireImage(require("./common/checkmark_green.svg")),
  greenCheckmarkSignUp: requireImage(require("./common/checkmark_20px_box.svg")),
  greenCheckmarkWhite: requireImage(require("./common/green_checkmark_white.svg")),
  hspIconGrey: requireImage(require("./common/hsp_icon_grey.svg")),
  humanIcon: requireImage(require("./common/human_icon.svg")),
  humanIconBlack: requireImage(require("./common/human_icon_black.svg")),
  humanLog: requireImage(require("./common/human_log.svg")),
  humanUnknownLog: requireImage(require("./common/human_unknown_log.svg")),
  iconCopy: requireImage(require("./common/icon_copy.svg")),
  iconDelete: requireImage(require("./common/icon_delete.svg")),
  iconDeleteGray: requireImage(require("./common/icon_delete_gray.svg")),
  iconEdit: requireImage(require("./common/icon_edit.svg")),
  idpLogo: requireImage(require("./common/idp_logo.svg")),
  idpLogoHover: requireImage(require("./common/idp_logo_hover.svg")),
  infoIcon: requireImage(require("./common/info_icon.svg")),
  leftArrow: requireImage(require("./common/left_arrow_icon.svg")),
  leftArrowLight: requireImage(require("./common/left_arrow_light.svg")),
  lLogo: requireImage(require("./common/l_logo.svg")),
  locationIcon: requireImage(require("./common/location_icon.svg")),
  logoutIconBlack: requireImage(require("./common/logout_icon_black.svg")),
  lukeHead: requireImage(require("./common/luke_head.svg")),
  lukeLogo: requireImage(require("./common/stockify_logo_with_name.svg")),
  lukeLogoLogin: requireImage(require("./common/stockify_logo_with_name.svg")),
  lukeLogoShort: requireImage(require("./common/head_landing.svg")),
  lukeText: requireImage(require("./common/luke_text.svg")),
  add: requireImage(require("./common/add.svg")),
  lukeTimeline: requireImage(require("./common/luke_timeline_icon.svg")),
  main: requireImage(require("./common/main.svg")),
  maskBlack: requireImage(require("./common/mask_black.svg")),
  maskGreen: requireImage(require("./common/mask_green.svg")),
  maskGrey: requireImage(require("./common/mask_grey.svg")),
  mdcIconGrey: requireImage(require("./common/mdc_icon_grey.svg")),
  medicalRedCross: requireImage(require("./common/medical_red_cross.svg")),
  meGrey: requireImage(require("./common/me_grey.svg")),
  menuArrowBlack: requireImage(require("./common/menu_arrow_black.svg")),
  microsoftLogo: requireImage(require("./common/microsoft_logo.svg")),
  myAccountIconBlack: requireImage(require("./common/my_account_icon_black.svg")),
  nfrLogo: requireImage(require("./common/nfr_logo.svg")),
  noMaskRed: requireImage(require("./common/no_mask_red.svg")),
  noPicture: requireImage(require("./common/no_picture.svg")),
  noTag: requireImage(require("./common/no_tag.svg")),
  noteIcon: requireImage(require("./common/note_icon.svg")),
  notificationIconBlack: requireImage(require("./common/notification_icon_black.svg")),
  nuvoolaLogo: requireImage(require("./common/stockify_logo_with_name.svg")),
  jrvLogo: requireImage(require("./common/JRV-logo.png")),
  deleteWarningTriangle: requireImage(require("./common/red_triangle_warning.svg")),
  supply_chain: requireImage(require("./common/Supply_chain.svg")),
  check_green: requireImage(require("./common/check_green.svg")),
  odometerIcon: requireImage(require("./common/odometer_icon.svg")),
  ovalmark: requireImage(require("./common/ovalmark.svg")),
  overrideIconBlack: requireImage(require("./common/override_black.svg")),
  overrideIconGrey: requireImage(require("./common/override_grey.svg")),
  overrideIconGreyLight: requireImage(require("./common/override_grey_light.svg")),
  overrideIconWhite: requireImage(require("./common/override_white.svg")),
  paletteIconBlack: requireImage(require("./common/palette_icon_black.svg")),
  pedestrianIcon: requireImage(require("./common/pedestrian_icon.svg")),
  phoneIcon: requireImage(require("./common/phone_icon.svg")),
  plusIconBlack: requireImage(require("./common/plus_icon_black.svg")),
  plusIconDarkGrey: requireImage(require("./common/plus_icon_dark_grey.svg")),
  plusIconGrey: requireImage(require("./common/plus_icon_grey.svg")),
  plusIconWhite: requireImage(require("./common/plus_icon_white.svg")),
  profilesIconGrey: requireImage(require("./common/profiles_icon_grey.svg")),
  questionMark: requireImage(require("./common/question_mark.svg")),
  redCrossCircle: requireImage(require("./common/red_cross_circle.svg")),
  relationIcon: requireImage(require("./common/relation_icon.svg")),
  requireAssistanceGrey: requireImage(require("./common/require_assistance_grey.svg")),
  requireAssistanceIcon: requireImage(require("./common/require_assistance.svg")),
  requireAssistanceOrange: requireImage(require("./common/requires_assistance_orange.svg")),
  requireAssistanceWhite: requireImage(require("./common/require_assistance_white.svg")),
  rfidMatched: requireImage(require("./common/rfid_matched.svg")),
  rfidUnmatched: requireImage(require("./common/rfid_unmatched.svg")),
  rightArrow: requireImage(require("./common/right_arrow_icon.svg")),
  rightArrowBlack: requireImage(require("./common/right_arrow_black.svg")),
  rightArrowLight: requireImage(require("./common/right_arrow_light.svg")),
  round: requireImage(require("./common/edit.svg")),
  edit_vmi: requireImage(require("./common/edit-vmi.svg")),
  save: requireImage(require("./common/save.svg")),
  host_icon_black: requireImage(require("./common/host_icon_black.svg")),
  appointment_black: requireImage(require("./common/appointment_black.svg")),
  schedulerIcon: requireImage(require("./common/scheduler_icon.svg")),
  schedulerIconArrow: requireImage(require("./common/scheduler_icon_arrow.svg")),
  sealIcon: requireImage(require("./common/seal_icon.svg")),
  searchIcon: requireImage(require("./common/search_icon.svg")),
  searchIconGreen: requireImage(require("./common/search_icon_green.svg")),
  searchIconGrey: requireImage(require("./common/search_icon_grey.svg")),
  searchIconWhite: requireImage(require("./common/search_icon_white.svg")),
  siteEntranceIconBlack: requireImage(require("./common/site_entrance_icon_black.svg")),
  siteViewIconBlack: requireImage(require("./common/site_view_icon_black.svg")),
  stopIcon: requireImage(require("./common/stop_icon.svg")),
  successIcon: requireImage(require("./common/success_icon.svg")),
  sendEmailIcon: requireImage(require("./common/send_mail.svg")),
  tabHistoryBlack: requireImage(require("./common/tab_history_black.svg")),
  tabHistoryDisabled: requireImage(require("./common/tab_history_disabled.svg")),
  tailgatingIcon: requireImage(require("./common/tailgating_icon.svg")),
  tailgatingIconGrey: requireImage(require("./common/tailgating_icon_grey.svg")),
  temperatureButton: requireImage(require("./common/temperature_button.svg")),
  temperatureButtonDisabled: requireImage(require("./common/temperature_button_disabled.svg")),
  temperatureButtonGreen: requireImage(require("./common/temperature_button_green.svg")),
  temperatureButtonRed: requireImage(require("./common/temperature_button_red.svg")),
  temperatureGreen: requireImage(require("./common/temperature_green.svg")),
  temperatureGrey: requireImage(require("./common/temperature_grey.svg")),
  temperatureIcon: requireImage(require("./common/temperature_icon.svg")),
  temperatureIconGrey: requireImage(require("./common/temperature_icon_grey.svg")),
  temperatureRed: requireImage(require("./common/temperature_red.svg")),
  tfiInternationalLogo: requireImage(require("./common/tfi_international_logo.svg")),
  threatFlag: requireImage(require("./common/threat_flag.svg")),
  topArrow: requireImage(require("./common/top_arrow_icon.png")),
  topbarInfos: requireImage(require("./common/topbar_infos.svg")),
  trailerAnim: requireImage(require("./animations/trailer.gif")),
  trailerIcon: requireImage(require("./common/trailer_icon.svg")),
  trailerIconBlack: requireImage(require("./common/trailer_icon_black.svg")),
  trailerIconDarkGrey: requireImage(require("./common/trailer_icon_dark_grey.svg")),
  trailerLog: requireImage(require("./common/trailer_log.svg")),
  trailerUnknownLog: requireImage(require("./common/trailer_unknown_log.svg")),
  truckIcon: requireImage(require("./common/vehicle_icon.svg")),
  truckIconBlack: requireImage(require("./common/truck_icon_black.svg")),
  truckIconDarkGrey: requireImage(require("./common/truck_icon_dark_grey.svg")),
  truckLog: requireImage(require("./common/truck_log.svg")),
  truckUnknownLog: requireImage(require("./common/truck_unknown_log.svg")),
  unknownDriver: requireImage(require("./common/unknown_driver.svg")),
  unknownHuman: requireImage(require("./common/unknown_human.svg")),
  unknownIconGrey: requireImage(require("./common/unknown_icon_grey.svg")),
  bin_product_associated: requireImage(require("./common/product_associated.svg")),
  unknownTrailer: requireImage(require("./common/unknown_trailer.svg")),
  unknownContainer: requireImage(require("./common/unknown_container.svg")),
  unknownTruck: requireImage(require("./common/unknown_truck.svg")),
  uploadArrowWhite: requireImage(require("./common/upload_arrow_white.svg")),
  userLoginIcon: requireImage(require("./common/user_login_icon.svg")),
  vehicleAnim: requireImage(require("./animations/truck.gif")),
  vehicleIcon: requireImage(require("./common/vehicle_icon.svg")),
  verificationBlue: requireImage(require("./common/verification_blue.svg")),
  verificationGreen: requireImage(require("./common/verification_green.svg")),
  verificationIconOk: requireImage(require("./common/verification_icon_ok.svg")),
  verificationIconWarning: requireImage(require("./common/verification_icon_warning.svg")),
  verificationLookup: requireImage(require("./common/verification_lookup.svg")),
  verificationOrange: requireImage(require("./common/verification_orange.svg")),
  verificationRed: requireImage(require("./common/verification_red.svg")),
  verifyIconBlue: requireImage(require("./common/verify_icon_blue.svg")),
  visitIcon: requireImage(require("./common/visit_icon.svg")),
  walkInIcon: requireImage(require("./common/walk_in_icon.svg")),
  walkInOutGrey: requireImage(require("./common/walk_in_out_grey.svg")),
  print: requireImage(require("./common/print.svg")),
  walkOutIcon: requireImage(require("./common/walk_out_icon.svg")),
  warningIcon: requireImage(require("./common/warning_icon.svg")),
  deleteWarning: requireImage(require("./common/warning_red_round_icon.svg")),
  warningCircleIcon: requireImage(require("./common/warning_circle_icon.svg")),
  warningTriangleOrange: requireImage(require("./common/warning_triangle_orange.svg")),
  zoomInGreen: requireImage(require("./common/zoom_in_green.svg")),
  zoomInIcon: requireImage(require("./common/zoom_in_icon.svg")),
  zoomOutGreen: requireImage(require("./common/zoom_out_green.svg")),
  zoomOutIcon: requireImage(require("./common/zoom_out_icon.svg")),
  sidebarTrain: requireImage(require("./common/train_icon_sidebar.svg")),
  locomotiveIcon: requireImage(require("./common/locomotive_icon.svg")),
  trainSidebar: requireImage(require("./common/locomotive.svg")),
};

const images = {
  ...common,
  ...(ENV === TFI ? tfi : dev),
};

export default images;
